export function get(key){
    return localStorage.getItem(key);
}

export function create(key, value){
    localStorage.setItem(key, value);
}

export function remove(key){
    localStorage.removeItem(key);
}

export function exists(key){
    if(localStorage.getItem(key) == null || localStorage.getItem(key) === ''){
        return false;
    }
    else{
        return true;
    }
}

export var localStorageKey = {
    tokenKey: "token-compliace",
    permissionKey: "permission-compliance",
    roleKey: "role-compliance"
}